import React, { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { api } from "../../../lib/api";

export const UserPicker = ({ value, onPick }) => {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (value || q.trim().length < 2) return setRows([]);
    const t = setTimeout(() => api.adminUsers({ q: q.trim(), limit: 6 }).then((r) => setRows(r.slice(0, 6))).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q, value]);

  if (value) return (
    <div className="flex items-center gap-3 rounded-xl border border-sky-200 bg-sky-50 px-3 py-2.5" data-testid="add-credit-selected-user">
      <div className="min-w-0 flex-1"><p className="text-sm font-medium text-slate-900 truncate">{value.name}</p><p className="text-xs text-slate-500 truncate">{value.email}</p></div>
      <button type="button" onClick={() => onPick(null)} data-testid="add-credit-change-user" className="text-xs text-sky-700 hover:underline">Change</button>
    </div>
  );
  return (
    <div className="space-y-1.5">
      <div className="relative">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
        <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search merchant by name or email" data-testid="add-credit-user-search"
          className="w-full h-10 pl-9 pr-3 rounded-xl bg-slate-50 border border-slate-200 text-sm text-slate-900 outline-none focus:border-sky-400 focus:bg-white" />
      </div>
      {rows.map((u) => (
        <button type="button" key={u.id} onClick={() => onPick(u)} data-testid={`add-credit-user-option-${u.id}`}
          className="w-full flex items-center justify-between gap-3 rounded-lg px-3 py-2 text-left hover:bg-slate-100 transition-colors">
          <span className="min-w-0"><span className="block text-sm text-slate-900 truncate">{u.name}</span><span className="block text-xs text-slate-500 truncate">{u.email}</span></span>
          <span className="text-xs font-mono text-slate-500 shrink-0">{u.credits_free + u.credits_paid} cr</span>
        </button>
      ))}
    </div>
  );
};

export default UserPicker;
